package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import com.exura.components.icons.UntiledIcon
import com.exura.ui.Assets
import com.exura.util.AriaCurrent
import com.exura.util.ariaCurrent
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun NavigationScope.NavigationLink(
    path: String,
    text: String,
    icon: @Composable () -> Unit,
) {
    val ctx = rememberPageContext()
    val currentPath = ctx.route.path.removeSuffix("/")
    val targetPath = path.removeSuffix("/")

    val isActive = if (targetPath == "") currentPath == "" else currentPath.startsWith(targetPath)

    Link(
        path = targetPath,
        modifier = NavNavigableElementStyle
            .toModifier()
            .ariaCurrent(if (isActive) AriaCurrent.Page else null),
    ) {
        NavigationItemContent(
            icon = icon,
            text = text,
            isCollapsed = isNavigationCollapsed,
        ) {
            if (isActive) {
                UntiledIcon(Assets.IconsUntiled.NAV_BUTTON_SELECTED)
            }
        }
    }
}
